module.exports = __webpack_public_path__ + "static/media/id_member_back.03e2301d.jpg";